import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import {
  toggleFeaturesSelector,
  visibleFeaturesiltersSelector,
} from '@/states/filters/features.state';

import { FilterBlocks } from '../../filters/filter-blocks/filter-blocks';

import styles from './features-filter.module.scss';

export const FeaturesFilter: React.FC = () => {
  const visibleFeatures = useRecoilValue(visibleFeaturesiltersSelector);
  const toggleFeatureFilter = useSetRecoilState(toggleFeaturesSelector);

  return (
    <div className={styles.features}>
      <div className={styles.featureSection}>
        <FilterBlocks
          label="Features"
          filters={visibleFeatures}
          onSelect={(optionId) => toggleFeatureFilter(optionId)}
        />
      </div>
    </div>
  );
};
